import _ from 'lodash';
import {
	OFFLINE_TRANSACTION_LIST_UPDATE_SUCCESS,
	OFFLINE_TRANSACTION_REMOVE_BEGIN,
	OFFLINE_TRANSACTION_REMOVE_FAIL,
	OFFLINE_TRANSACTION_REMOVE_SUCCESS,
	SEARCH_TRANSACTIONS_ON_PAGE,
	SEARCH_TRANSACTIONS_SORT_CHANGE,
	SEARCH_TRANSACTIONS_TEXT_CHANGE,
	readSavedSearchSort,
} from "../actions/transactions.js";
import { SORT_BEST_MATCH, SORT_NEWEST } from "../../utilities/transactionFinder/transactionSearch.js";
import { UPDATE_REFRESH_SUCCESS } from "../actions/dashboard.js";
import findTransactionByRenderKey from "../../utilities/findTransactionByRenderKey.js";

const defaultState = {
	transactionSearchText: '',
	// What the list is searched with: the text, once typing pauses.
	transactionSearchQuery: '',
	transactionSearchSort: readSavedSearchSort() === SORT_NEWEST ? SORT_NEWEST : SORT_BEST_MATCH,
	offlineTransactions: [],
	sendingOfflineTransactions: false,
};

/**
 *
 * @param state
 * @param action
 * @param transactionFinder {TransactionFinder}
 * @returns {{transactionSearchText: *}}
 */
export default function(state = defaultState, action, allState) {
	switch(action.type) {
		case OFFLINE_TRANSACTION_REMOVE_BEGIN: {
			return {
				...state,
				sendingOfflineTransactions: true
			};
		}
		case OFFLINE_TRANSACTION_REMOVE_FAIL:
		case OFFLINE_TRANSACTION_REMOVE_SUCCESS: {
			return {
				...state,
				sendingOfflineTransactions: false
			};
		}
		case OFFLINE_TRANSACTION_LIST_UPDATE_SUCCESS: {
			return {
				...state,
				offlineTransactions: action.payload,
			};
		}
		case UPDATE_REFRESH_SUCCESS: {
			const transactionBeingEdited = allState.dashboard.transactionBeingEdited;
			const found = _.isString(transactionBeingEdited) &&
				findTransactionByRenderKey(allState.dashboard.transactionFinder, transactionBeingEdited);
			if(!found) {
				return state;
			}
			allState.dashboard.transactionBeingEdited = found;
			allState.dashboard.transactionBeingEditedModalShouldBeOpen = true;
			return state;
		}
		case SEARCH_TRANSACTIONS_ON_PAGE: {
			return {
				...state,
				transactionSearchQuery: action.payload,
			};
		}
		case SEARCH_TRANSACTIONS_TEXT_CHANGE: {
			return {
				...state,
				transactionSearchText: action.payload,
			};
		}
		case SEARCH_TRANSACTIONS_SORT_CHANGE: {
			return {
				...state,
				transactionSearchSort: action.payload === SORT_NEWEST ? SORT_NEWEST : SORT_BEST_MATCH,
			};
		}
		default:
			return state;
	}
}